export enum LouisEventType {
    CLICK_EVENT = 'ClickEvent',
}
